module.exports = __webpack_public_path__ + "img/patel-brothers.81ae6fb2.jpg";